import Home from '../Home.vue'
import modelList from './list.vue'
import modelAdd from './add.vue'
import modelEdit from './edit.vue'
import modelDesign from './design.vue'

const routes = [
  {
    path: '/home',
    component: Home,
    children: [
      { path: '/model/list', component: modelList, name: 'modelList', meta: { hideLeft: false, menuGet: '', module: 'Administrative', menu: 'model' }},
      { path: '/model/add', component: modelAdd, name: 'modelAdd', meta: { hideLeft: false, menuGet: '', module: 'Administrative', menu: 'model' }},
      { path: '/model/edit', component: modelEdit, name: 'modelEdit', meta: { hideLeft: false, menuGet: '', module: 'Administrative', menu: 'model' }},
      { path: '/model/design', component: modelDesign, name: 'modelDesign', meta: { hideLeft: true, menuGet: '', module: 'Administrative', menu: 'model' }}
    ]
  }
]
export default routes



// WEBPACK FOOTER //
// ./src/components/Model/routes.js